(() => {
  const header = document.querySelector('[data-header]');
  const megaMenu = document.querySelector('[data-mega-menu]');
  if (header && megaMenu) {
    const triggers = header.querySelectorAll('[data-mega-trigger]');
    const panels = megaMenu.querySelectorAll('[data-mega-panel]');

    const closeMega = () => {
      megaMenu.classList.remove('is-open');
      panels.forEach((panel) => panel.classList.remove('is-open'));
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    };

    const openMega = (id) => {
      megaMenu.classList.add('is-open');
      panels.forEach((panel) => panel.classList.toggle('is-open', panel.dataset.megaPanel === id));
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === id)));
    };

    triggers.forEach((trigger) => {
      const id = trigger.dataset.megaTrigger;
      trigger.addEventListener('mouseenter', () => openMega(id));
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        isOpen ? closeMega() : openMega(id);
      });
    });

    header.addEventListener('mouseleave', closeMega);
    megaMenu.querySelector('[data-mega-close]')?.addEventListener('click', closeMega);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMega();
    });
    // The panel/scrim are positioned relative to the header, not fixed to the
    // viewport, so scrolling the page away from the header leaves them open
    // and dimming content that has scrolled into view. Close on scroll.
    window.addEventListener('scroll', closeMega, { passive: true });
  }

  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerOpenBtn = document.querySelector('[data-drawer-open]');
  if (drawer && drawerOpenBtn) {
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      drawerOpenBtn.focus();
    };
    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      drawer.querySelector('[data-drawer-close]')?.focus();
    };

    drawerOpenBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    drawer.querySelectorAll('[data-accordion-group] details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        drawer.querySelectorAll('[data-accordion-group] details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  }
})();
